import { gql } from '@apollo/client'

export const grantUserCourse = gql`
  mutation GrantUserCourse($user: String!, $course: String!) {
    userCourseUpsertOne(user: $user, course: $course)
  }
`
